import { Component, input, output } from "@angular/core";
import {
  PageToolbarItemType,
  PageTooolbarItem
} from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item";
import { PageToolbarItemComponent } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item.component";

@Component({
  selector: "snt-page-toolbar-switch",
  template: "",
  providers: [
    {
      provide: PageToolbarItemComponent,
      useExisting: PageToolbarSwitchComponent
    }
  ],
  standalone: false
})
export class PageToolbarSwitchComponent implements PageTooolbarItem {
  type: PageToolbarItemType = "switch";

  onText = input<string | undefined>(undefined);
  offText = input<string | undefined>(undefined);
  label = input<string | undefined>(undefined);

  valueChanged = output<boolean>();

  onValueChanged(value: boolean): void {
    this.valueChanged.emit(value);
  }
}
